import { DataTable, Panel } from "@/components/ui";
import type { DataTableColumn } from "@/components/ui";

import { Paged } from "../components/Paged";
import type { SpaceRow } from "../types";

import { useSpaceRunRows, type RunListRow } from "./lib/runs";

const COLUMNS: DataTableColumn<RunListRow>[] = [
  { key: "started", header: "Started", mono: true },
  { key: "ended", header: "Ended", mono: true },
  { key: "activity", header: "Activity", emphasis: true },
  { key: "version", header: "Version", mono: true, width: "90px" },
  { key: "ended_by", header: "Ended by", muted: true },
];

function match(row: RunListRow, needle: string): boolean {
  return `${row.activity} ${row.version} ${row.ended_by} ${row.started}`
    .toLowerCase()
    .includes(needle);
}

/** Runs over this space, newest first. One row per mount the space has held. */
export function SpaceRuns({ space }: { readonly space: SpaceRow }) {
  const rows = useSpaceRunRows(space.space.space_id);

  return (
    <Panel>
      {rows.length > 0 ? (
        <Paged rows={rows} pageSize={12} placeholder="Find a run" match={match}>
          {(page) => (
            <DataTable caption="Runs" density="comfortable" columns={COLUMNS} rows={page} />
          )}
        </Paged>
      ) : (
        <DataTable
          caption="Runs"
          density="comfortable"
          columns={COLUMNS}
          rows={[]}
          emptyHeadline="No runs yet"
        />
      )}
    </Panel>
  );
}
